export const formSubmitValueMapper = (data = {}) => ({
  tgl_seleksi_vendor_aset: data?.tgl_seleksi_vendor_aset ?? undefined,
  no_seleksi_vendor_aset: data?.no_seleksi_vendor_aset ?? '',
  harga_kesepakatan: data?.harga_kesepakatan ?? 0,
  id_vendor: data?.id_vendor ?? undefined,
  nama_vendor: data?.nama_vendor ?? '',
  id_permintaan_aset_detail: data?.id_permintaan_aset_detail ?? undefined,
  id_seleksi_vendor_aset: data?.id_seleksi_vendor_aset ?? undefined,
});
